export const PUBLIC_PATHS = {
  LOGIN: "/login",
  UPDATE_PASSWORD: "/update-password",
  FORGOT_PASSWORD: "/forgot-password",
};

export const PRIVATE_PATHS = {
  DASHBOARD: "/dashboard",
  STAFF: "/staff",
  STAFF_DETAILS: "/staff/:id",
  WORK_LOG: "/work-log",
  DIGITAL_MARKETER: "/work-log/digital-marketer",
  FNANCE_ACTIVITY: "/work-log/finance-activity",
  SALES_ACTIVITY: "/work-log/sales-activity",
  ADD_NEW_LOG: "/work-log/add-new-log",
  OPERATIONS_LOG: "/work-log/operations-log",
  DIGITAL_MARKETER_LOG: "/work-log/digital-marketer-log",
  FINANCIAL_ACTIVITY_LOG: "/work-log/finance-activity-log",
  SALES_ACTIVITY_LOG: "/work-log/sales-activity-log",
  CLIENT_MGT: "/client-mgt",
  CLIENT_MGT_LEADS: "/client-mgt/leads",
  CLIENT_MGT_LEAD_DETAILS: "/client-mgt/leads/:id",
  CLIENT_MGT_ASSIGN_LEAD_DETAILS: "/client-mgt/leads/assign/:id",
  CLIENT_MGT_CLIENTS: "/client-mgt/clients",
  CLIENT_MGT_SERVICES: "/client-mgt/clients/:id/services",
  CLIENT_MGT_CREATE_LEAD: "/client-mgt/lead/create",
  ACC_MGT: "/account-mgt",
  ACC_MGT_DETAILS: "/account-mgt/:id",
  ACC_MGT_CREATE_ACCOUNT: "/account-mgt/create",
  DEPTS: "/settings/departments",
  JOB_TTILES: "/settings/job-titles",
  SYSTEM_ROLES: "/settings/system-roles",
  STRATEGY: "/settings/strategy",
  ADD_ROLES: "/settings/system-roles/create",
  EDIT_ROLES: "/settings/system-roles/:id",
  PERMISSIONS: "/settings/permissions",
  ADD_PERMISSION: "/settings/permissions/create",
  EDIT_PERMISSION: "/settings/permissions/:id",
};
